import { produce } from 'immer'
export const createControlSlice = (set) => ({
  quad1: {
    color: "color6",
    shape: "quarterCircle",
    rotation: 180,
  },
  quad2: {
    color: "color1",
    shape: "triangle",
    rotation: 0,
  },
  quad3: {
    color: "color1",
    shape: "triangle",
    rotation: 0,
  },
  quad4: {
    color: "color1",
    shape: "square",
    rotation: 0,
  },
  setQuad1Val: (key, val) =>
    set(
      produce((state) => {
        state.quad1[key] = val
      })
    ),
  setQuad2Val: (key, val) =>
    set(
      produce((state) => {
        state.quad2[key] = val
      }
    )),
  setQuad3Val: (key, val) =>
    set(
      produce((state) => {
        state.quad3[key] = val
      }
    )),
  setQuad4Val: (key, val) =>
    set(
      produce((state) => {
        state.quad4[key] = val
      }
    )),
  setQuad1: (val) => set({ quad1: val }),
  setQuad2: (val) => set({ quad2: val }),
  setQuad3: (val) => set({ quad3: val }),
  setQuad4: (val) => set({ quad4: val }),
})